import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useMutation } from "@apollo/client";
// Icons
import { BiMinusCircle } from "react-icons/bi";
// Srcs
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_MATERIAL, UPDATE_MATERIAL } from "../../Schema/Material";
import {
  SelectUnit,
  SelectSize,
  SelectCategory,
  SelectGroup,
  SelectSection,
  SelectLevelSection,
} from "../Include/DynamicSelect";


export default function MaterialForm({
  editData,
  open,
  handleClose,
  setRefetch,
  dialogTitle,
  defaultSectionSelected, 
  typeOfView,
  handleOpenListItem
}) {
  
  //
  const { setAlert, noneUserAccesse } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [sizeVal, setSizeVal] = useState({ id: "", title: "" });
  const [sectionVal, setSectionVal] = useState({ id: "", title: "" });
  const [levelSectionVal, setLevelSectionVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });
  const [categoryVal, setCategoryVal] = useState({ id: "", title: "" });
  const [smallUnitVal, setSmallUnitVal] = useState({ id: "", title: "" });

  const [checked, setChecked] = useState(false);
  // console.log("check", checked);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  // ======================== Create Material ==============================
  const [createMaterial] = useMutation(CREATE_MATERIAL, {
    onCompleted: ({ createMaterial }) => {
      setLoading(false);
      if (createMaterial?.status) {
        setAlert(true, "success", createMaterial?.message);
        handleClose();
        setRefetch();

        if(typeOfView && typeOfView === "ListAllItem") {
          handleOpenListItem();
        }

      } else {
        setAlert(true, "error", createMaterial?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // ======================== Update Material ==============================
  const [updateMaterial] = useMutation(UPDATE_MATERIAL, {
    onCompleted: ({ updateMaterial }) => {
      setLoading(false);
      if (updateMaterial?.status) {
        setAlert(true, "success", updateMaterial?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateMaterial?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // ======================== Formik =======================================
  const CheckValidation = Yup.object().shape({
    isbm: Yup.string(),
    categoryId: Yup.string().required("ទាមទារ!"),    
    sectionId: Yup.string(),
    levelSectionId: Yup.string(),
    groupId: Yup.string(),
    materialKhName: Yup.string().required("ទាមទារ!"),
    materialEnName: Yup.string().required("ទាមទារ!"),
    smallUnitId: Yup.string().required("ទាមទារ!"),
    sizeId: Yup.string(),
    remark: Yup.string(),
    defaultPrice: Yup.number().required().min(0),
    //isLongTerm: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      isbm: "",
      categoryId: "",
      sectionId: "",
      levelSectionId: "",
      groupId: "",
      materialKhName: "",
      materialEnName: "",
      smallUnitId: "",
      sizeId: "",
      remark: "",
      defaultPrice: 0,
      //isLongTerm: false,
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createMaterial({
          variables: {
            input: {
              ...values,
              sectionId: values.sectionId ? values.sectionId : null,
              levelSectionId: values.levelSectionId
                ? values.levelSectionId
                : null,
              groupId: values?.groupId ? values?.groupId : null,
              isLongTerm: checked,
              sizeId: values?.sizeId ? values?.sizeId : null,
            },
          },
        });
      } else {
        updateMaterial({
          variables: {
            id: editData?._id,
            input: {
              ...values,
              sectionId: values.sectionId ? values.sectionId : null,
              levelSectionId: values.levelSectionId
                ? values.levelSectionId
                : null,
              groupId: values?.groupId ? values?.groupId : null,
              isLongTerm: checked,
              sizeId: values?.sizeId ? values?.sizeId : null,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
    values,
  } = formik;

  //====================== Set Value To Formik ====================
  useEffect(() => {    
    setFieldValue("sectionId", sectionVal?.id  ? sectionVal?.id : "");
    setFieldValue("levelSectionId", levelSectionVal?.id ? levelSectionVal?.id : "" );
    setFieldValue("sizeId", sizeVal?.id ? sizeVal?.id : "");
    setFieldValue("groupId", groupVal?.id ? groupVal?.id : "");
    setFieldValue("categoryId", categoryVal?.id ? categoryVal?.id : "");
    setFieldValue("smallUnitId", smallUnitVal?.id ? smallUnitVal?.id : "");
  }, [
    smallUnitVal,
    groupVal,
    sizeVal,
    categoryVal,
    sectionVal,
    levelSectionVal,
  ]); 

  //================= Set default Value For Create =================
  useEffect(() => {    
    if (dialogTitle === "Create") { 
      resetForm();

      if(defaultSectionSelected?.id) {
        setSectionVal(defaultSectionSelected);
      } else {
        setSectionVal({ id: "", title: "" });
      }
      
      setLevelSectionVal({ id: "", title: "" }); 
      setGroupVal({ id: "", title: "" }); 
      setSizeVal({ id: "", title: "" }); 
      setCategoryVal({ id: "", title: "" });
      setSmallUnitVal({ id: "", title: "" });
    }
  },[open])
 


  //================= Set Value For Update =================
  useEffect(() => {  
    if (editData && dialogTitle !== "Create") {
      setFieldValue("materialEnName", editData?.materialEnName);
      setFieldValue("materialKhName", editData?.materialKhName);
      setFieldValue("remark", editData?.remark);
      setFieldValue("isbm", editData?.isbm ? editData?.isbm : "");
      setFieldValue("defaultPrice", editData?.defaultPrice ? editData?.defaultPrice : 0);

      setSectionVal({
        id: editData?.sectionId?._id,
        title: editData?.sectionId?.sectionKhName,
      });
      setLevelSectionVal({
        id: editData?.levelSectionId?._id,
        title: editData?.levelSectionId?.levelSectionEnName,
      });
      setSizeVal({
        id: editData?.sizeId?._id,
        title: editData?.sizeId?.sizeKhName,
      });
      setCategoryVal({
        id: editData?.categoryId?._id,
        title: editData?.categoryId?.categoryKhName,
      });
      setGroupVal({
        id: editData?.groupId?._id,
        title: editData?.groupId?.groupKhName,
      });
      setSmallUnitVal({
        id: editData?.smallUnitId?._id,
        title: editData?.smallUnitId?.unitKhName,
      });
    }
  }, [open, editData]);
  

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {dialogTitle === "Create" ? "បង្កើតសម្ភារៈ" : "កែប្រែសម្ភារៈ"}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={6}>
                <Typography className="field-title">កូដ/ISBN</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder=""
                  {...getFieldProps("isbm")}
                  error={Boolean(
                    touched?.isbm && errors?.isbm
                  )}
                  helperText={touched?.isbm && errors?.isbm}
                />
              </Grid>
              <Grid item xs={6}></Grid>

              <Grid item xs={6}>
                <Typography className="field-title">សម្ភារៈជាខ្មែរ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="100ml, 200ml, 500g,..."
                  {...getFieldProps("materialKhName")}
                  error={Boolean(
                    touched?.materialKhName && errors?.materialKhName
                  )}
                  helperText={touched?.materialKhName && errors?.materialKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">
                  សម្ភារៈជាអង់គ្លេស
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="100ml, 200ml, 500g,..."
                  {...getFieldProps("materialEnName")}
                  error={Boolean(
                    touched?.materialEnName && errors?.materialEnName
                  )}
                  helperText={touched?.materialEnName && errors?.materialEnName}
                />
              </Grid>

              {noneUserAccesse(["StockController", "Proposer"]) ? null : (
                <Grid item xs={6}>
                  <Typography className="field-title">ផ្នែក</Typography>
                  <SelectSection
                    selectedVal={sectionVal}
                    setSelectedVal={setSectionVal}
                    disabled={defaultSectionSelected?.id ? true : false}
                  />
                </Grid>
              )}

              
              <Grid item xs={6}>
                <Typography className="field-title">កម្រិតផ្នែក</Typography>
                <SelectLevelSection
                  selectedVal={levelSectionVal}
                  setSelectedVal={setLevelSectionVal}
                />
              </Grid>
              

              <Grid item xs={6}>
                <Typography className="field-title">ប្រភេទ</Typography>
                <SelectCategory
                  selectedVal={categoryVal}
                  setSelectedVal={setCategoryVal}
                  isUse={true}
                  error={
                    values?.categoryId === ""
                      ? Boolean(touched?.categoryId && errors?.categoryId) ||
                        categoryVal === null
                      : false
                  }
                  helperText={
                    values?.categoryId === ""
                      ? (touched?.categoryId && errors?.categoryId) ||
                        (categoryVal === null && "require!")
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">ក្រុម</Typography>
                <SelectGroup
                  isUse={true}
                  selectedVal={groupVal}
                  setSelectedVal={setGroupVal}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">ឯកតា (តូចបំផុត)</Typography>
                <SelectUnit
                  selectedVal={smallUnitVal}
                  setSelectedVal={setSmallUnitVal}
                  error={
                    values?.smallUnitId === ""
                      ? Boolean(touched?.smallUnitId && errors?.smallUnitId) ||
                        smallUnitVal === null
                      : false
                  }
                  helperText={
                    values?.smallUnitId === ""
                      ? (touched?.smallUnitId && errors?.smallUnitId) ||
                        (smallUnitVal === null && "require!")
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">ទំហំ</Typography>
                <SelectSize selectedVal={sizeVal} setSelectedVal={setSizeVal} />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">សម្រាប់</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="រយៈពេលវែង"
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">តម្លៃ</Typography>
                <TextField
                  className="text-field"
                  type="number"
                  fullWidth 
                  size="small"
                  placeholder="defaultPrice"
                  {...getFieldProps("defaultPrice")}
                  error={Boolean(touched?.defaultPrice && errors?.defaultPrice)}
                  helperText={touched?.defaultPrice && errors?.defaultPrice}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Create" ? "បង្កើត" : "កែប្រែ"}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
